module.exports = "/_next/static/images/harajuku_shinise_top-e59f48b8f705035245842de90942bd4b.jpg";